import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';
import OutsideClickHandler from 'react-outside-click-handler';

// ---------------------------------------------------------

import Icon from '@components/icon';
import Button from '@components/button';

import { pushStateToQuery } from '@lib/query-utils';

// ---------------------------------------------------------

import {
  filter_apply_button,
  filter_button,
  filter_content_inner,
  filter_container,
  filters_are_showing,
  filter_content
} from '../styles.module.scss';

// ---------------------------------------------------------

const FilterDropDownButton = (props) => {
  const router = useRouter();
  let { children, label } = props;

  const reduxParams = useSelector((state) => state.searchFilters);

  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);

  const applyFilters = () => {
    pushStateToQuery(router, reduxParams, true);
    setDropdownIsOpen(false);
  };

  // ---------------------------------------------------------

  return (
    <div
      className={classNames(filter_container, {
        [filters_are_showing]: dropdownIsOpen
      })}
    >
      <OutsideClickHandler onOutsideClick={() => setDropdownIsOpen(false)}>
        <button
          aria-expanded={dropdownIsOpen}
          aria-controls={label}
          className={filter_button}
          onClick={() => setDropdownIsOpen(!dropdownIsOpen)}
        >
          {label}
          <Icon name="small-down" type="arrow" />
        </button>

        <AnimateHeight
          animateOpacity={true}
          className={filter_content}
          contentClassName={filter_content_inner}
          duration={400}
          height={dropdownIsOpen ? 'auto' : 0}
          id={label}
        >
          {children}
          <Button
            className={filter_apply_button}
            type="button"
            label="Apply Filters"
            onClick={applyFilters}
          />
        </AnimateHeight>
      </OutsideClickHandler>
    </div>
  );
};

FilterDropDownButton.propTypes = {
  /**
   * Specifies the children coming from the filter component
   */
  children: PropTypes.node,

  /**
   * Specifies the height of the current dropdown
   */
  filterHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Specifies the label coming from the filter component
   */
  label: PropTypes.string,

  /**
   * Function to update the height of the current dropdown
   */
  setFilterHeight: PropTypes.func
};

FilterDropDownButton.defaultProps = {};

export default FilterDropDownButton;
